/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `LockOpenIconProps` interface defines the properties for the LockOpenIcon component.
 */
interface LockOpenIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "lock_open" — outlined, weight 300.
 * Unlock icon for CTA buttons.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const LockOpenIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'LockOpenIcon',
    width
}: LockOpenIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h360v-80q0-50-35-85t-85-35q-42 0-74 25.5T366-748l-58-14q15-62 64.5-110T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-60h480q8 0 14-6t6-14v-400q0-8-6-14t-14-6H240q-8 0-14 6t-6 14v400q0 8 6 14t14 6Zm240-140q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM220-140v-460 460Z" />
    </svg>
);

LockOpenIcon.displayName = 'LockOpenIcon';